import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { RoundedIcon } from '../../ui-kit/Icon/RoundedIcon.js';
export const renderRoundedIcon = (icon, iconBgVersion) => (_jsx(RoundedIcon, { ...icon, iconBgVersion: iconBgVersion, className: "shrink-0" }));
//# sourceMappingURL=renderRoundedIcon.js.map